import React from 'react'
import { DateTime } from 'luxon'
import FormPlateInput from 'parkdepot-shared/components/LPInput'
import { useTranslation } from 'react-i18next'
import CarpayPaymentResult from '../CarpayPaymentFinished.component'
import { Time } from '../../PaymentFinished.style'

interface PaymentPendingProps {
    plate: string
    now: DateTime
}

const PaymentPending = ({ plate, now }: PaymentPendingProps) => {
    const { t } = useTranslation()

    return (
        <CarpayPaymentResult>
            <CarpayPaymentResult.Icon variant="Pending" className="wemolo-clock" />
            <CarpayPaymentResult.Title variant="Pending">
                {t('carpay.paymentFinished.pending')}
            </CarpayPaymentResult.Title>
            <CarpayPaymentResult.Subtitle>{t('carpay.paymentFinished.pendingSubtitle')}</CarpayPaymentResult.Subtitle>
            <div>
                <FormPlateInput disabled readOnly value={plate} />
                <Time>{now.toFormat('dd.MM.yyyy HH:mm')}</Time>
            </div>
        </CarpayPaymentResult>
    )
}

export default PaymentPending
